import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import connect from './connect';

class SectionTemplateSelector extends React.Component {
  static propTypes = {
    multi: PropTypes.bool,
    onSelect: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props);

    this.getOptions = this.getOptions.bind(this);
    this.handleSelect = this.handleSelect.bind(this)
  }
  getOptions(inputValue) {
    if(this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.props.fetchSectionTemplates({
        size: 50,
        filters: { title: { $regex: `${inputValue}`, $options: 'gi' } }
      })
    }, 1000);

  }
  handleSelect(selected) {
    if(!this.props.onSelect) {
      return console.warn('You must provide a SectionTemplateSelector.onSelect(selected: Array | any)');
    }

    this.props.onSelect(
      this.props.multi?
        selected.map(({ value }) => value) :
        selected.value
    );
  }
  componentDidMount() {
    this.props.fetchSectionTemplates({ size: 50 });
  }
  render() {
    const { section_templates, multi } = this.props;
    const [ section_template ] = section_templates;
    const {
      size,
      total,
      results,
      downloading
    } = this.props.section_template_manager;
    return (
      <Select
        multi={multi}
        onChange={this.handleSelect}
        onInputChange={this.getOptions}
        isLoading={downloading}
        options={[
          ...(section_templates || []),
          ...results
            .filter(section_template => !section_templates.find(i => i._id == section_template._id))
        ].map(section_template => ({ label: section_template.title, value: section_template._id }))}
        placeholder='Find Page Templates'
        value={multi ? (section_templates || []).map(({_id}) => _id) : (section_template || {})._id}
      />
    );
  }
};

export default connect(SectionTemplateSelector);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/section-template-selector.js